module.exports = __webpack_public_path__ + "static/media/playtowin_terms.82997af1.pdf";